import { getWPModuleSpacing } from "@app/api/wp-page-fetcher/utils/get-wp-module-spacing";
import { moduleMapperThrowMessage } from "@app/api/wp-page-fetcher/utils/module-mapper-error-handling";
import { IModuleFetcher } from "@app/api/wp-page-fetcher/module-selector/module-selector";
import Logger from "@app/util/logger";
import { MyDealAlertsModule } from "@app/api/modules/my-deal-alerts/my-deal-alerts.module";

import { WP_MODULES } from "../../module-names";
import { IWPMyDealAlertsModuleFull } from "./my-deal-alerts-module.interface";

export interface IMyDealAlertsModuleMapper extends IModuleFetcher {
  module: IWPMyDealAlertsModuleFull;
}

export const myDealAlertsModuleMapper = async (
  props: IMyDealAlertsModuleMapper
): Promise<MyDealAlertsModule | undefined> => {
  try {
    const {
      module: { data, meta }
    } = props;
    if (!data) return moduleMapperThrowMessage("No data found in myDealAlertsModuleMapper");

    return {
      id: WP_MODULES.MY_DEAL_ALERTS.id,
      name: WP_MODULES.MY_DEAL_ALERTS.wpName,
      ...getWPModuleSpacing(meta?.separators, meta?.setMargins),
      background: { backgroundColour: meta?.bgColor },
      ...data
    };
  } catch (e) {
    Logger.logError(e, "Error in: myDealAlertsModuleMapper");

    return undefined;
  }
};
